import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
// 公司认证
import authRouter from '@/router/modules/auth'
import { useI18n } from '@/plugins/i18n'
const { t } = useI18n()

const Home = () => import('../layout/home.vue')
const HomeBase = () => import('../layout/home-base.vue')
const HomeAuth = () => import('../layout/home-auth.vue')

/**
 * wildcard route
 */
export const wildcardRoute = {
  path: '/:catchAll(.*)',
  hidden: true,
  redirect: '/404',
}

/**
 * async routes
 */
export const asyncRoutes = [
  {
    path: '/',
    redirect: '/dashboard',
    meta: { title: t('enum.text_1'), nav: true },
    component: Home,
    children: [
      {
        path: '/dashboard',
        meta: { title: t('enum.text_1'), icon: '工作台' },
        component: () => import('../views/dashboard/indexV2.vue'),
      },
    ],
  },
  {
    path: '/auth/authType',
    meta: { title: t('enum.text_5') },
    component: HomeAuth,
    hidden: true,
    children: [
      {
        path: '/auth/authType',
        meta: { title: t('enum.text_5') },
        component: () => import('../views/auth/select-auth-type'),
      },
    ],
  },
  {
    path: '/user/personal',
    meta: { title: t('enum.text_6') },
    component: Home,
    hidden: true,
    children: [
      {
        path: '/user/personal',
        meta: { title: t('enum.text_6') },
        component: () => import('../views/user/personal'),
      },
    ],
  },
  {
    path: '/client',
    component: Home,
    alwaysShow: true,
    meta: { title: t('enum.text_16'), nav: true, icon: '客户列表' },
    children: [
      {
        path: 'noUseClient',
        meta: { title: t('enum.text_17') },
        component: () => import('../views/client/noUseClient.vue'),
      },
      {
        path: 'list',
        meta: { title: t('enum.text_18') },
        component: () => import('../views/client/index.vue'),
      },
    ],
  },
  {
    path: '/client/check-account',
    component: Home,
    hidden: true,
    meta: { title: 'check-account' },
    children: [
      {
        path: '/client/check-account',
        meta: { title: 'check-account' },
        component: () => import('../views/client/check-account.vue'),
      },
    ],
  },
  {
    path: '/collection/list',
    component: Home,
    meta: { title: t('enum.text_3') },
    children: [
      {
        path: '/collection/list',
        meta: { title: t('enum.text_3'), icon: '收款列表' },
        component: () => import('../views/collection/index.vue'),
      },
    ],
  },
  {
    path: '/trade/list',
    component: Home,
    meta: { title: t('enum.text_4') },
    children: [
      {
        path: '/trade/list',
        meta: { title: t('enum.text_4'), icon: '交易列表' },
        component: () => import('../views/trade/index.vue'),
      },
    ],
  },
  {
    path: '/settlement',
    component: Home,
    alwaysShow: true,
    meta: { title: t('enum.text_13'), nav: true, icon: '结算管理' },
    children: [
      {
        path: 'partner',
        meta: { title: t('enum.text_14') },
        component: () => import('../views/settlement/index.vue'),
      },
      {
        path: 'sales',
        meta: { title: t('enum.text_15') },
        component: () => import('../views/settlement/sales-settlement.vue'),
      },
    ],
  },
  {
    path: '/settlement/confirm-order',
    component: Home,
    hidden: true,
    meta: { title: '确认账单' },
    children: [
      {
        path: '/settlement/confirm-order',
        meta: { title: '确认账单', icon: '交易列表' },
        component: () => import('../views/settlement/confirm-order.vue'),
      },
    ],
  },
  authRouter, // 认证
]

/**
 * constant routes
 */
export const constantRoutes = [
  {
    path: '/',
    hidden: true,
    redirect: '/dashboard',
  },
  {
    path: '/register-success',
    hidden: true,
    meta: { title: t('enum.text_7') },
    component: () => import('../views/user/register-success.vue'),
  },
  {
    path: '/',
    component: HomeBase,
    children: [
      {
        path: '/register',
        name: 'Register',
        hidden: true,
        meta: { title: t('enum.text_8') },
        component: () => import('../views/user/register.vue'),
      },
      {
        path: '/forgetPassword',
        name: 'ForgetPassword',
        hidden: true,
        meta: { title: t('enum.text_9') },
        component: () => import('../views/user/forget-password.vue'),
      },
      {
        path: '/login',
        name: 'Login',
        hidden: true,
        meta: { title: t('enum.text_10') },
        component: () => import('../views/user/login.vue'),
      },
    ],
  },
  {
    path: '/404',
    name: '404',
    hidden: true,
    meta: { title: '找不到页面' },
    component: () => import('../views/404.vue'),
  },
  {
    path: '/401',
    name: '401',
    hidden: true,
    meta: { title: '没有权限' },
    component: () => import('../views/401.vue'),
  },
]

/**
 * create local router
 * @returns {*}
 */
const createLocalRouter = () => createRouter({
  // history: createWebHashHistory(),
  history: createWebHistory(),
  routes: constantRoutes,
})

/**
 * reset local router
 */
export function resetLocalRouter() {
  const newRouter = createLocalRouter()
  router.matcher = newRouter.matcher
  router.options.routes = constantRoutes
}

const router = createLocalRouter()

export default router
